// extracted by mini-css-extract-plugin
export default {"DashboardLayout":"DashboardLayout_DashboardLayout__EQw+d","header":"DashboardLayout_header__yy1p8"};